import React from 'react';
import MyPhoto from '../assests/myPhoto.jpg'
import Navigation from './Navigation';
import Footer from './Footer';

const Bio = () => {
    return (
        <>
            <Navigation />
            <div className='container'>
                <div className="bio-container">
                    <div className="my-photo-container">
                        <img src={MyPhoto} alt="Photo of Malaya Manjula" />
                    </div>
                    <div className="text-container">
                        <p>Hi, I’m Malaya Manjula, a skilled Full Stack Web Developer, 3D Graphic Designer, and Dynamic Poster Designer based in Jharsuguda, Odisha. I specialize in creating high-performance websites, immersive 3D visuals, and eye-catching promotional posters for businesses, startups, and individuals.</p>
                        <p>Whether you need a custom website, 3D product modeling, branding materials, or social media graphics, I deliver high-quality, fast, and scalable solutions tailored to your needs.</p>
                        <p>Let’s build something remarkable together! <span>See some of my work <a href="https://www.instagram.com/monty3366/">here.</a></span></p>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
};

export default Bio;